export const TUTORIAL_FOLDER = "Tutorial";
export const TUTORIAL_LESSON_ID_STORAGE_KEY = "tutorialCurrentLessonId";
export const MONGO_ID_PATTERN = /^[a-f\d]{24}$/i;
export const MONGO_ID_AT_END_PATTERN = /([a-f\d]{24})$/i;
export const TUTORIAL_ACTIONS = {
  READ: "read",
  NOTES: "notes",
  FLASHCARDS: "flashcards",
};

export const getPublicPathId = (lessonOrId) => {
  if (!lessonOrId) return "";
  if (typeof lessonOrId === "string") return lessonOrId;
  return lessonOrId.publicPathId || lessonOrId._id || "";
};

export const extractPublicLessonId = (lessonPathId = "") => {
  if (MONGO_ID_PATTERN.test(lessonPathId)) return lessonPathId;
  const idMatch = String(lessonPathId).match(MONGO_ID_AT_END_PATTERN);
  return idMatch ? idMatch[1] : lessonPathId;
};

export const getPublicLessonPath = (lessonOrId) =>
  `/public/lesson/${getPublicPathId(lessonOrId)}`;

export const getPublicNotesPath = (lessonOrId) =>
  `/public/notes/${getPublicPathId(lessonOrId)}`;

export const getPublicFlashcardsPath = (lessonOrId) =>
  `/public/flashcards/${getPublicPathId(lessonOrId)}`;

export const getTutorialLessonPath = () => "/tutorial/lesson";

export const getTutorialNotesPath = () => "/tutorial/notes";

export const getTutorialFlashcardsPath = () => "/tutorial/flashcards";

export const getTutorialSubjectsPath = (action = TUTORIAL_ACTIONS.READ) =>
  `/tutorial/subjects?action=${encodeURIComponent(action)}`;

export const isTutorialLesson = (lesson) =>
  lesson?.title === TUTORIAL_FOLDER;

export const getTutorialLessonSubject = (lesson) =>
  lesson?.chapter?.trim() || lesson?.author?.trim() || "Untitled subject";

export const sortTutorialLessons = (lessons = []) =>
  [...lessons].sort((left, right) =>
    getTutorialLessonSubject(left).localeCompare(getTutorialLessonSubject(right)),
  );

export const selectTutorialLesson = (lessons = []) =>
  sortTutorialLessons(lessons).find((lesson) => isTutorialLesson(lesson)) || null;

export const rememberTutorialLessonId = (lessonId) => {
  if (typeof window === "undefined" || !lessonId) return;
  window.localStorage.setItem(TUTORIAL_LESSON_ID_STORAGE_KEY, lessonId);
};

export const getRememberedTutorialLessonId = () => {
  if (typeof window === "undefined") return "";
  return window.localStorage.getItem(TUTORIAL_LESSON_ID_STORAGE_KEY) || "";
};
